import { InfoOutlined } from "@mui/icons-material";
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { DialogType } from "../../utils/constants";
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';



export const SimpleDialog = ({selfCloseModal,...props} )=>{


    let IconModal =  <></>;

    if (props.type === DialogType.informativo){
     IconModal = <InfoOutlined  sx={{fontSize:'50px'}} color="info" />
    }else if(props.type === DialogType.peligro){
        IconModal = <DisabledByDefaultRoundedIcon sx={{fontSize:'50px'}}  color="error" />
    }else if(props.type === DialogType.exitoso){
        IconModal = <CheckCircleRoundedIcon  sx={{fontSize:'50px'}} color="success" />
    }else{

    }
  
    return(<Dialog
    open={props.isVisible}
    sx={{
      zIndex:'10000'
    }}
    {...(props.aditionalProps || {})}
    
    >
      <DialogContent>
        <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}} >
            {IconModal}
            <DialogTitle 
            sx={{justifyContent:"center",alignContent:"center",alignItems:"center"}} 
            >  {props.title}
            </DialogTitle>
            {
              typeof props.message === 'string'?
              <DialogContent  dangerouslySetInnerHTML={{__html:props.message}} />:
          <DialogContent  >
              {props.message}
          </DialogContent>
            }

          <Button onClick={selfCloseModal} type="button"  sx={{marginTop:'15px'}} variant="contained" color="primary" >Aceptar</Button>
        </div>
      
    </DialogContent>
        
    </Dialog>)
}
